import type React from 'react';
import type { SearchResultProps } from './types';
import FdocList from '../../FdocList/FdocList';
import { useResourceListPreferencesContext } from '@fabric-app/business/resources/components/ResourceList/contexts/resourceListContextPreferences';

const resourcePreviewProps = {
  appearence: {
    showRootInFilename: true,
  },
};

export const SearchResultsFabricItems: React.FC<SearchResultProps> = ({
  isLoading,
  resources,
  total,
  fetchNextPage,
  queryHash,
  emptyStateTitle,
  emptyStateReason,
  zoomLevel,
  setZoomLevel,
}) => {
  const { viewMode } = useResourceListPreferencesContext();

  return (
    <FdocList
      layoutId={`searchbar-overlay-${queryHash}`}
      multiSelectLayerId="searchbar-with-overlay"
      resources={resources}
      viewMode={viewMode}
      onInfiniteTrigger={fetchNextPage}
      emptyStateImage={<img src="/images/empty-search.png" alt="empty-search" />}
      canMultiSelect={true}
      canModifyContent
      zoomLevel={zoomLevel}
      setZoomLevel={setZoomLevel}
      emptyStateTitle={emptyStateTitle}
      emptyStateReason={emptyStateReason}
      isLoading={isLoading}
      resourcesTotalCount={total}
      skipAnimation
      resourcePreviewProps={resourcePreviewProps}
      uiContext="search"
      defaultPadding="42px 42px 95px 42px"
    />
  );
};
